import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import Dashboard from './routes/dashboard/Dashboard';
import Reports from './routes/reports/Reports';
import Settings from './routes/settings/Settings';
import ErrorPage from './routes/ErrorPage';
import RegisterPage from './routes/register/RegisterPage';
import LoginPage from './routes/login/LoginPage';
import ProtectedRoute from './auth/ProtectedRoute';
import {AuthProvider, useAuth} from './auth/authContext';
import SingleReports from './routes/reports/singleReports/SingleReports';
import FutureProjects from "./routes/futureProjects/FutureProjects.jsx";

function AppRoutes() {
    const {user} = useAuth();

    return (
        <Routes>
            {/* Wenn der Benutzer eingeloggt ist, direkt zum Dashboard umleiten */}
            <Route path="/" element={<Navigate to="/dashboard"/>}/>
            <Route
                path="dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="reports"
                element={
                    <ProtectedRoute>
                        <Reports/>
                    </ProtectedRoute>
                }
            /> <Route
            path="future-projects"
            element={
                <ProtectedRoute>
                    <FutureProjects/>
                </ProtectedRoute>
            }
        />
            <Route
                path="settings"
                element={
                    <ProtectedRoute>
                        <Settings/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="reports/:hapakid"
                element={
                    <ProtectedRoute>
                        <SingleReports/>
                    </ProtectedRoute>
                }
            />

            {/* LoginPage und RegisterPage nur zugänglich, wenn der Benutzer nicht eingeloggt ist */}
            <Route
                path="register"
                element={user ? <Navigate to="/dashboard"/> : <RegisterPage/>}
            />
            <Route
                path="login"
                element={user ? <Navigate to="/dashboard"/> : <LoginPage/>}
            />
            <Route path="*" element={<ErrorPage/>}/>
        </Routes>
    );
}

function App() {
    return (
        <Router>
            <AuthProvider>
                <AppRoutes/>
            </AuthProvider>
        </Router>
    );
}

export default App;

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>

        <App/>

    </React.StrictMode>
);
